import { RelationType, WhereItem } from "../../globalTypes";

const VALUE_BASED_RELATION_TYPES = [
  RelationType.Like,
  RelationType.TextValue,
  RelationType.NumberValue,
  RelationType.DateValue,
  RelationType.DateValueDynamic,
  RelationType.DateValueRange,
  RelationType.DynamicValue,
  RelationType.BooleanValue,
  RelationType.SelectValue,
] as const;

export type ValueBasedRelationTypes = typeof VALUE_BASED_RELATION_TYPES[number];
export type ValueBasedWhereItem = WhereItem & {
  relation: { type: ValueBasedRelationTypes };
};

function isTypeValueBased(
  testedRelationType: RelationType
): testedRelationType is ValueBasedRelationTypes {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return VALUE_BASED_RELATION_TYPES.includes(testedRelationType as any);
}

export function isItemValueBased(item: WhereItem): item is ValueBasedWhereItem {
  return isTypeValueBased(item.relation.type);
}

export type ListWhereItem = WhereItem & { isList: true };
export function isItemList(item: WhereItem): item is ListWhereItem {
  return item.isList;
}
